import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { MobileNav } from './MobileNav';
import { useIsMobile } from '@/hooks/useMediaQuery';
import { useUIStore } from '@/stores/ui';
import { clsx } from 'clsx';

export function Shell() {
  const isMobile = useIsMobile();
  const { sidebarOpen } = useUIStore();

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-gray-50">
      {/* Desktop sidebar */}
      {!isMobile && (
        <div
          className={clsx(
            'shrink-0 h-full transition-all duration-200',
            !sidebarOpen && 'hidden',
          )}
        >
          <Sidebar />
        </div>
      )}

      {/* Main area */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <TopBar />

        {/* Page content */}
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>

        {/* Mobile bottom navigation */}
        {isMobile && <MobileNav />}
      </div>
    </div>
  );
}
